import { render, staticRenderFns } from "./DashboardCardElement.vue?vue&type=template&id=40ecaa6d&scoped=true&"
import script from "./DashboardCardElement.ts?vue&type=script&lang=ts&"
export * from "./DashboardCardElement.ts?vue&type=script&lang=ts&"
import style0 from "./DashboardCardElement.scss?vue&type=style&index=0&id=40ecaa6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ecaa6d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon})
